import contactLinkDirective from './ContactLinkDirective';
import ContactUtilsSvc from './ContactUtilsService';
import 'edge/platform/widgets/modal/module';

export default angular.module('edge.platform.contacts', ['edge.platform.widgets.modal']).factory('ContactUtils', ContactUtilsSvc).directive('gwPlContactLink', contactLinkDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/contacts/module.js
// module id = 1028
// module chunks = 0